export default {
    methods: {
      getChanged(ad) {
        if(ad.allow_quantity){
          return this.returnChangeObj(parseInt(ad.iniQuantity), parseInt(ad.quantity));
        }else{
          return this.returnChangeObj(ad.iniSelected, ad.selected);
        }
      },
      getChangedGroup(group) {
        if(group.iniSelected!==group.selected){
          return {changed:true,text:'selection changed',color:'secondary'};
        }else{
          return {changed:false,text:'',color:'body'};
        }
      },
      returnChangeObj(initial_value,current_value){
        let obj_a = {text:'added',color:'secondary'}; // Added
        let obj_r = {text:'removed',color:'error'}; // Removed
        let obj_c = {text:'changed',color:'body'}; // Changed
        let obj_n = {text:'',color:'body'}; // No Change
  
        if(typeof initial_value==='boolean'&&typeof current_value==='boolean'){
          initial_value = (initial_value)?1:0;  current_value = (current_value)?1:0;
        }
  
        if(initial_value===current_value){ return obj_n; }
        if(initial_value===0&&current_value>0){ return obj_a; }
        if(initial_value>0&&current_value===0){ return obj_r; }
        if((initial_value>1&&(current_value<initial_value&&current_value!==0))||initial_value>0&&current_value>initial_value){ return obj_c; }
      },
    },
  }
